<template>
  <div
    class="upp"
    @click.stop
  >
    <div class="upp-head">
      <p class="upp-title">
        {{ title }}
      </p>
      <input
        v-model="query"
        type="text"
        class="upp-search"
        placeholder="Buscar unidade ou equipe…"
      >
    </div>

    <div
      ref="list"
      class="upp-list custom-scroll"
    >
      <button
        v-if="rootAllowed && matchesQuery('Instituição')"
        type="button"
        class="upp-node upp-root"
        :class="{ 'is-selected': isRootChosen }"
        @click="pickRoot"
      >
        <span
          class="upp-check"
          :class="{ 'is-on': isRootChosen }"
        />
        <span class="upp-node-name">Instituição (raiz)</span>
      </button>

      <team-tree-branch
        :nodes="visibleTree"
        tag="button"
        :is-chosen="isChosen"
        @pick="pick"
      >
        <template #before="{ node }">
          <span
            class="upp-check"
            :class="{ 'is-on': isChosen(node.id) }"
          />
        </template>
      </team-tree-branch>

      <p
        v-if="visibleTree.length === 0 && !(rootAllowed && matchesQuery('Instituição'))"
        class="upp-empty"
      >
        Nenhuma unidade ou equipe encontrada.
      </p>
    </div>
  </div>
</template>

<script>
import TeamTreeBranch from "./TeamTreeBranch.vue";

export default {
  components: { "team-tree-branch": TeamTreeBranch },
  props: {
    tree: { type: Array, default: () => [] },
    rootAllowed: { type: Boolean, default: false },
    title: { type: String, default: "Selecione a unidade superior" },
    currentId: { type: [Number, String], default: null }
  },
  emits: ["select"],
  data() {
    return {
      query: "",
      chosen: undefined,
      chosenRoot: false
    };
  },
  computed: {
    nodeById() {
      const map = {};
      const walk = (nodes) => {
        (nodes || []).forEach((node) => {
          map[String(node.id)] = node;
          walk(node.children);
        });
      };
      walk(this.tree);
      return map;
    },
    visibleTree() {
      const q = this.query.trim().toLowerCase();
      if (!q) return this.tree;
      const filter = (nodes) =>
        (nodes || []).reduce((out, node) => {
          const children = filter(node.children);
          const selfMatch = (node.name || "").toLowerCase().includes(q);
          if (selfMatch || children.length) {
            out.push({ ...node, children: selfMatch ? node.children : children });
          }
          return out;
        }, []);
      return filter(this.tree);
    },
    isRootChosen() {
      return this.chosenRoot === true;
    }
  },
  created() {
    if (this.currentId != null && this.nodeById[String(this.currentId)]) {
      this.markNode(this.currentId);
    } else if (this.currentId == null && this.rootAllowed) {
      this.markRoot();
    }
  },
  mounted() {
    const list = this.$refs.list;
    const selected = list && list.querySelector(".is-selected");
    if (!selected) return;

    const listBox = list.getBoundingClientRect();
    const selectedBox = selected.getBoundingClientRect();
    list.scrollTop += selectedBox.top - listBox.top - (listBox.height - selectedBox.height) / 2;
  },
  methods: {
    matchesQuery(text) {
      const q = this.query.trim().toLowerCase();
      return !q || text.toLowerCase().includes(q);
    },
    isChosen(id) {
      return (
        !this.chosenRoot &&
        this.chosen !== undefined &&
        String(this.chosen.id) === String(id)
      );
    },
    markNode(id) {
      const node = this.nodeById[String(id)];
      if (!node) return false;
      this.chosenRoot = false;
      this.chosen = { id: node.id, name: node.name, isTeam: !!node.isTeam };
      return true;
    },
    markRoot() {
      this.chosenRoot = true;
      this.chosen = undefined;
    },
    pick(id) {
      if (this.markNode(id)) this.$emit("select", this.chosen);
    },
    pickRoot() {
      this.markRoot();
      this.$emit("select", null);
    }
  }
};
</script>

<style scoped>
.upp {
  width: 320px;
  max-width: 88vw;
  background: #ffffff;
  border: 1px solid #e5e2ef;
  border-radius: 14px;
  box-shadow: 0 10px 30px rgba(36, 31, 51, 0.18);
  overflow: hidden;
}
.upp-head {
  padding: 13px 15px 12px;
  border-bottom: 1px solid #eceaf3;
}
.upp-title {
  margin: 0 0 10px;
  font-size: 14px;
  font-weight: 640;
  color: #3a3a3a;
}
.upp-search {
  width: 100%;
  box-sizing: border-box;
  border: 1px solid #e5e2ef;
  background: #faf9fd;
  border-radius: 999px;
  padding: 8px 14px;
  font-size: 13px;
  color: #3a3a3a;
  outline: none;
}
.upp-search:focus {
  border-color: #9a397d;
}
.upp-list {
  padding: 6px 4px 4px;
  max-height: 320px;
  overflow-y: auto;
}
.upp-node {
  display: flex;
  align-items: center;
  gap: 10px;
  width: 100%;
  background: transparent;
  border: none;
  text-align: left;
  padding: 9px 12px;
  border-radius: 8px;
  cursor: pointer;
  font-size: 14px;
  color: #3a3a3a;
  font-family: inherit;
}
.upp-node:hover {
  background: #faf9fd;
}
.upp-node.is-selected {
  background: rgba(79, 63, 130, 0.1);
}
.upp-node.is-selected .upp-node-name {
  color: #4f3f82;
  font-weight: 600;
}
.upp-root {
  border-bottom: 1px solid #f0eef7;
  margin-bottom: 4px;
}
.upp-node-name {
  flex: 1 1 auto;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.upp-check {
  width: 16px;
  height: 16px;
  border-radius: 5px;
  border: 1.5px solid #d9d5e6;
  flex: none;
  position: relative;
  background: #ffffff;
}
.upp-check.is-on {
  border-color: #4f3f82;
  background: #4f3f82;
}
.upp-check.is-on::after {
  content: "";
  position: absolute;
  left: 4px;
  top: 1px;
  width: 4px;
  height: 8px;
  border: solid #ffffff;
  border-width: 0 2px 2px 0;
  transform: rotate(45deg);
}
.upp-empty {
  padding: 18px;
  text-align: center;
  color: #9a9a9a;
  font-size: 13px;
  margin: 0;
}
</style>
